/**
 * Created by lycheng on 2017/11/23.
 * 产品服务页相关接口
 */
import 'babel-polyfill'
import { config } from 'config'
import { cookie } from 'js/libs/utils-cookie'

/**
 * 获取用户app
 * @param servicesId
 * @returns {Promise}
 */
function getServiceOpenApps (servicesId, getAppUrl) {
  return new Promise(function (resolve, reject) {
    var url = `/herapi/user/get_app_list_by_service?service_id=${btoa(servicesId)}`
    jQuery.ajax({
      url: getAppUrl || url,
      type: 'get',
      dataType: 'json',
      success: function (data) {
        resolve({
          code: 0,
          data: data
        })
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 获取用户app
 * 代替getServiceOpenApps
 */
function getApps () {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: `/herapi/product/getAppList`,
      type: 'get',
      dataType: 'json',
      cache: false,
      success: function (result) {
        resolve(result)
      },
      error: function (s) {
        resolve({})
      }
    })
  })
}

/**
 * 开通服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openService (servicesId, appId) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      type: 'get',
      url: `${config.API}mycloud/app/accessService`,
      dataType: 'json',
      data: {
        'app_id': appId,
        'service': servicesId
      },
      success: function (result) {
        resolve({
          code: 0,
          data: result
        })
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 开通ocr服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openOcrService (servicesId, appId) {
  return new Promise(function (resolve, reject) {
    let ssoSessionId = cookie.get('ssoSessionId')
    let accountId = cookie.get('account_id')
    $.ajax({
      type: 'get',
      url: `${config.CONSOLE}dashboard/app/jsonp/service/add`,
      dataType: 'jsonp',
      data: {
        appId: appId,
        services: servicesId,
        ssoSessionId: ssoSessionId,
        account_id: accountId
      },
      jsonp: 'callback',
      jsonpCallback: 'handleResponse',
      success: function (result) {
        resolve({
          code: 0,
          data: result
        })
      },
      error: function (result) {
        resolve(result)
      }
    })
  }).catch(function (reason) {
    console.log('catch:', reason)
  })
}

/**
 * 开通新框架服务的接口
 * @param servicesId
 * @param appId
 * @returns {Promise}
 */
function openNewFrameService (servicesId, appId) {
  return new Promise(function (resolve, reject) {
    let ssoSessionId = cookie.get('ssoSessionId')
    let accountId = cookie.get('account_id')
    $.ajax({
      type: 'get',
      url: `${config.CONSOLE}dashboard/webapi/jsonp/addService/v1`,
      dataType: 'jsonp',
      data: {
        appId: appId,
        services: servicesId,
        ssoSessionId: ssoSessionId,
        account_id: accountId
      },
      jsonp: 'callback',
      jsonpCallback: 'handleResponse',
      success: function (result) {
        resolve({
          code: 0,
          data: result
        })
      },
      error: function (result) {
        resolve(result)
      }
    })
  }).catch(function (reason) {
    console.log('catch:', reason)
  })
}

/**
 * 语音合成的接口
 * @param params：
 * {
 *   vcn: aisxping,
 *   vol: 7,
 *   spd: medium,
 *   textPut: '', // 输入的文本
 * }
 * @returns {Promise}
 */
function webTTS (params) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      type: 'post',
      url: '/herapi/solution/synthesis',
      dataType: 'json',
      data: params,
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

function mtranslate (params) {
  // {
  //   fromLang: trans.data.source,
  //     toLang: trans.data.dist,
  //   originText: text
  // }
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/translate',
      type: 'post',
      data: params,
      success: function (result) {
        // result.code = result.flag ? 0 : -1
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 获取开放统计的sdkList
 * @returns {Promise}
 */
function getMobileappSdkList () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/getSdkList',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 词法分析接口
 * @returns {Promise}
 */
function lexicalAnalysist (params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/index/webltp',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 机器翻译niutrans体验接口
 * @returns {Promise}
 */
function getOtsResult (params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/ots',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 机器翻译体验接口
 * @returns {Promise}
 */
function getItsResult (params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/its',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 关键词提取type传：ke
 * 如果是调用情感分析type传：sa
 * 关键词 && 情感分析接口
 * @returns {Promise}
 */
function productKesa (params) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/product/kesa',
      type: 'POST',
      dataType: 'json',
      data: params,
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 获取在线语音合成的音频src
 * @returns {Promise}
 */
function getOnlineAudioSrc (params, challenge, validate, seccode) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/solution/synthesis/v2?challenge=' + challenge + '&validate=' + validate + '&seccode=' + seccode,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(params),
      contentType: 'application/json; charset=utf-8',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

function getVoiceAudioSrc (params, challenge, validate, seccode) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/solution/dictation/v2?challenge=' + challenge + '&validate=' + validate + '&seccode=' + seccode,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(params),
      contentType: 'application/json; charset=utf-8',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 获取极验数据进行初始化
 * @returns {Promise}
 */
function getValidate () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/plug/validate',
      type: 'get',
      cache: false,
      dataType: 'json',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}
/**
 * 获取听写websocket链接
 * @returns {Promise}
 */
function getIatSign (geettestResult) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/iat_sign',
      type: 'post',
      dataType: 'json',
      cache: false,
      data: {
        challenge: geettestResult.geetest_challenge,
        validate: geettestResult.geetest_validate,
        seccode: geettestResult.geetest_seccode
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

function getIatLanguage () {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/iat_language_list',
      type: 'post',
      dataType: 'json',
      cache: false,
      success: function (data) {
        resolve(data)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 获取合成websocket链接
 * @returns {Promise}
 */
function getTtsSign (geettestResult) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/tts_sign',
      type: 'post',
      dataType: 'json',
      cache: false,
      data: {
        challenge: geettestResult.geetest_challenge,
        validate: geettestResult.geetest_validate,
        seccode: geettestResult.geetest_seccode
      },
      success: function (data) {
        resolve(data)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 合成体验发音人参数列表获取接口
 * @param grade 发音人等级（默认是0，0特色发音人，1精品发音人）
 * @returns {Promise}
 */
function getTtsSpeakList ({
  grade = 0
}) {
  return new Promise(function (resolve, reject) {
    jQuery.ajax({
      url: '/herapi/product/tts_language_list',
      type: 'post',
      dataType: 'json',
      data: {
        grade
      },
      cache: false,
      success: function (data) {
        resolve(data)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

export {
  getServiceOpenApps,
  getApps,
  getMobileappSdkList,
  openService,
  openOcrService,
  openNewFrameService,
  webTTS,
  mtranslate,
  lexicalAnalysist,
  getOtsResult,
  getItsResult,
  productKesa,
  getOnlineAudioSrc,
  getVoiceAudioSrc,
  getValidate,
  getIatSign,
  getIatLanguage,
  getTtsSpeakList,
  getTtsSign
}



// WEBPACK FOOTER //
// ./src/js/api/services.js